import { LandrBrand, StudioPlan, SamplesBrand } from 'constants/brands';
import { t } from '@lingui/macro';
import { Interval, BundleCatalog } from 'types/generated/subscriptionsApi';
import getPlanPrices from '../../helpers/getPlanPrices';

const useStudioPlan = ({
    frequency,
    hasSubscription,
    studioCatalog,
    getSaleDiscount,
}: {
    frequency: Interval;
    hasSubscription: boolean;
    studioCatalog: BundleCatalog | undefined;
    getSaleDiscount: (
        planCode?: string,
        frequency?: Interval,
    ) => number | undefined;
}) => {
    const title = `${LandrBrand} ${StudioPlan}`;
    const info = hasSubscription
        ? t`This new plan will be added to your current ${SamplesBrand} plan. You will get the credits that come with this plan immediately. You can manage your plans from your Account settings later.`
        : undefined;

    const planByFrequency = studioCatalog?.plans?.find(
        (plan) => plan?.frequency === frequency,
    );

    const discountPercentage = getSaleDiscount(
        planByFrequency?.code,
        frequency,
    );

    const {
        subscriptionPrice,
        monthlyEquivalentPrice,
        salePrice,
        monthlyEquivalentSale,
    } = getPlanPrices({
        subscriptionPrice: planByFrequency?.subscriptionPrice ?? 0,
        frequency,
        discountPercentage: discountPercentage,
    });

    return {
        title,
        info,
        currency: studioCatalog?.currency,
        subscriptionPrice: subscriptionPrice,
        monthlyEquivalentPrice: monthlyEquivalentPrice,
        code: planByFrequency?.code,
        salePrice: salePrice,
        monthlyEquivalentSale: monthlyEquivalentSale,
    };
};

export default useStudioPlan;
